import React, { useState, useEffect } from "react";
import BreadCrumb from "../../components/Cards/BreadCrumb";
import Header from "../../components/Sidebar/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import { useLocation } from "react-router-dom";
import orders from "../../icons/answer.svg";
import addIcon from "../../icons/add.svg";
import InfoCard from "../../components/Cards/Carts";
import Spiner from "../../components/Loader/Spiner";
import Add from "./Add";
import Edit from "./Edit";
import View from "./View";
import Cookies from "js-cookie";
import axios from "axios";
// Icons
import {
  ChatBubbleBottomCenterTextIcon,
  EyeIcon,
  PlusCircleIcon,
  QuestionMarkCircleIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { PencilIcon } from "@heroicons/react/24/outline";

// redux mapping
import { useDispatch, useSelector } from "react-redux";
import { getQuestion } from "../../../features/Global/Dashboard/AskVary";
// Grid
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import Toast from "../../components/Cards/Toast";
import Parser from "html-react-parser";
import { Tooltip } from "@mui/material";
const Index = () => {
  const [isHeadlessOpen, setIsHeadlessOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [view, setView] = useState(false);

  const dispatch = useDispatch();
  const data = useSelector((state) => state.AskVaryDashboard.data);
  const loader = useSelector((state) => state.AskVaryDashboard.loading);

  // Toast
  const [toast, setToast] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [editId, seteditId] = useState("");
  // hook to fetch items
  useEffect(() => {
    dispatch(getQuestion());
  }, []);
  const [pageSize, setPageSize] = useState(10);
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }
  const columns = [
    { field: "id", headerName: "id", width: 70 },
    {
      field: "qestion",
      headerName: "Question",
      minWidth: 240,
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params?.value} placement="top">
          <p>{params?.value}</p>
        </Tooltip>
      ),
    },
    {
      field: "answer",
      headerName: "Answer",
      minWidth: 240,
      flex: 1,
      renderCell: (cellvalues) => (
        <Tooltip title={cellvalues?.value} placement="top">
          <p
          // onClick={() => handleDelete(cellvalues?.id)}
          >
            {cellvalues?.row?.answer &&
              // cellvalues?.row?.answer.length > 0 &&
              Parser(cellvalues.row.answer)}
          </p>
        </Tooltip>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 220,
      flex: 1,
      renderCell: (cellvalues) => (
        <button
          onClick={() => handleDelete(cellvalues?.id)}
          className={`text-center inline-flex items-center justify-center px-3 py-1 mx-auto text-sm font-medium shadow-md ${
            cellvalues.row.status === true
              ? "text-emerald-700 bg-emerald-200 hover:bg-emerald-400-600 focus:ring-emerald-500 focus:ring-offset-emerald-200 f "
              : "text-rose-700 bg-rose-200 hover:bg-rose-400-600 focus:ring-rose-500 focus:ring-offset-rose-200"
          }  border-none rounded-md  focus:outline-none focus:ring-2 focus:ring-offset-2`}
        >
          {cellvalues.row.status === true ? "Active" : "Not Active"}
        </button>
      ),
    },
    {
      field: "insertedAt",
      headerName: "Inserted At",
      minWidth: 140,
      renderCell: (cellvalues) => (
        <span>
          {new Date(cellvalues.row.insertedAt)?.toLocaleString(undefined, {
            dateStyle: "short",
            timeStyle: "short",
          })}
        </span>
      ),
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      minWidth: 140,
      renderCell: (cellvalues) => (
        <span>
          {new Date(cellvalues.row.updatedAt)?.toLocaleString(undefined, {
            dateStyle: "short",
            timeStyle: "short",
          })}
        </span>
      ),
    },
    {
      field: "Edit",
      headerName: "Replay",
      width: 130,
      renderCell: (cellvalues) => (
        <button
          onClick={() => handleEdit(cellvalues.id)}
          type="button"
          className="flex items-center justify-center float-right w-full py-2 text-sm text-center text-white transition duration-200 ease-in bg-blue-600 rounded-lg shadow-md hover:bg-blue-700 focus:ring-blue-600 focus:ring-offset-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2"
        >
          <ChatBubbleBottomCenterTextIcon
            src={addIcon}
            alt="add icon"
            className="w-4 h-4 mr-2 text-white "
          />
          Answer
        </button>
      ),
    },
    // {
    //   field: "Delete",
    //   headerName: "Delete",
    //   width: 130,
    //   renderCell: (cellvalues) => (
    //     <button
    //       onClick={(e) => handleDelete(cellvalues.id)}
    //       type="button"
    //       className="flex items-center justify-center float-right w-full py-2 text-sm text-center text-white transition duration-200 ease-in rounded-lg shadow-md bg-rose-500 hover:bg-rose-600 focus:ring-rose-500 focus:ring-offset-rose-200 focus:outline-none focus:ring-2 focus:ring-offset-2 "
    //     >
    //       <TrashIcon
    //         src={addIcon}
    //         alt="add icon"
    //         className="w-4 h-4 mr-2 text-white "
    //       />
    //       Delete
    //     </button>
    //   ),
    // },
    {
      field: "View",
      headerName: "View",
      width: 130,
      renderCell: (cellvalues) => (
        <button
          onClick={() => handleView(cellvalues.row)}
          type="button"
          className="flex items-center justify-center float-right w-full px-3 py-2 text-base text-center text-white transition duration-200 ease-in bg-orange-500 rounded-lg shadow-md hover:bg-orange-600 focus:ring-orange-500 focus:ring-offset-secondary-200 focus:outline-none focus:ring-2 focus:ring-offset-2 "
        >
          <EyeIcon
            src={addIcon}
            alt="add icon"
            className="w-4 h-4 mr-2 text-white "
          />
          View
        </button>
      ),
    },
  ];
  const config = {
    headers: {
      Authorization: `Bearer ${Cookies.get("dashboardToken")}`,
    },
  };
  const handleEdit = (id) => {
    seteditId(id);
    setEdit(true);
  };
  const handleDelete = (id) => {
    axios
      .delete(`api/Questions/${id}`, config)
      .then((r) => {
        // console.log(r);
        if (r.status === 200 || r.status === 204) {
          setMessage("Question status updated successfully.");
          setToast(true);
          dispatch(getQuestion());
        }
        if (r.status === 204) {
          setToast(true);
          dispatch(getQuestion());
        }
      })
      .catch((e) => {
        console.log(e.response.data);
        setMessage(e.response.data);
        setError(true);
      });
  };
  const handleView = (id) => {
    seteditId(id);
    setView(true);
  };
  return (
    <div className="ltr">
      <main className="relative h-screen bg-gray-100 dark:bg-gray-800">
        <div className="flex items-start justify-between h-screen overflow-y-auto">
          <Sidebar />
          <div className="flex flex-col w-full h-screen overflow-y-auto md:space-y-4">
            <header className="z-10 flex items-center justify-between w-full h-16">
              {/* <div className="block ml-6 lg:hidden">
                <button className="flex items-center p-2 text-gray-500 bg-white rounded-full shadow text-md">
                  <svg
                    width="20"
                    height="20"
                    className="text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 1792 1792"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1664 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"></path>
                  </svg>
                </button>
              </div> */}
              {/* Header */}
              <Header />
            </header>
            <div className="h-screen px-4 pb-24 overflow-auto md:px-6 dark:bg-gray-900">
              <div className="">
                <BreadCrumb
                  page={"Ask Vary"}
                  icon={<QuestionMarkCircleIcon className="inline w-6 mx-2" />}
                />
              </div>
              <InfoCard />
              <div className="p-4 rounded-md bg-gray-50 dark:bg-gray-800">
                {edit && (
                  <Edit
                    Title={"Answer Question"}
                    open={edit}
                    id={editId}
                    setOpen={setEdit}
                  />
                )}{" "}
                {view && (
                  <View
                    Title={"View Qestion"}
                    open={view}
                    setOpen={setView}
                    id={editId}
                  />
                )}
                <br />
                <br />
                {/* {loader && <Spiner />} */}
                {loader ? (
                  <>
                    <Spiner />
                  </>
                ) : (
                  <div className=" h-[44rem] items-center w-auto mt-2 dark:bg-gray-800">
                    <DataGrid
                      rows={data}
                      columns={columns}
                      className="dark:bg-gray-800 dark:text-gray-200"
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      rowsPerPageOptions={[10, 20, 50, 100]}
                      components={{
                        Toolbar: CustomToolbar,
                      }}
                    />
                  </div>
                )}
                {toast && (
                  <Toast Text={message} Type={"secondary"} setOpen={setToast} />
                )}
                {error && (
                  <Toast Text={message} Type={"rose"} setOpen={setError} />
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Index;
